<template>
    <div>
        <h1 class="display-heading">E-Wallet Facility Application</h1>
        <p>
            To facilitate e-wallet payment of patients and consolidate major
            e-wallet providers within one mobile app.
            <br />
            Ipay 88 installation fee – absorbed by Digital Savvy
        </p>

        <div class="mb-3">
            <div class="mb-2">
                <a
                    href="/static/docs/e-wallet-solution.pdf"
                    target="_blank"
                    class="btn btn-primary btn-primary-insv"
                    >Click Here to Read More</a
                >
            </div>

            <div class="mb-2">
                <a
                    href="/static/docs/market-rates.pdf"
                    target="_blank"
                    class="btn btn-primary btn-primary-insv"
                    >Click Here to View Retail Fees</a
                >
            </div>

            <div class="mb-2">
                <a
                    href="/static/docs/e-wallet-application-form.pdf"
                    target="_blank"
                    class="btn btn-primary btn-primary-insv"
                    >Click Here to Download Application Form</a
                >
            </div>
        </div>
        <div v-if="!hasApplied" class="card p-2">
            <div class="bs-stepper">
                <div class="bs-stepper-header" role="tablist">
                    <!-- your steps here -->
                    <div class="step" data-target="#select-company-type">
                        <button
                            type="button"
                            class="step-trigger"
                            role="tab"
                            aria-controls="select-company-type"
                            id="select-company-type-trigger"
                        >
                            <span class="bs-stepper-circle">1</span>
                            <span class="bs-stepper-label">Select Company Type</span>
                        </button>
                    </div>
                    <div class="line"></div>
                    <div class="step" data-target="#documents-to-prepare">
                        <button
                            type="button"
                            class="step-trigger"
                            role="tab"
                            aria-controls="documents-to-prepare"
                            id="documents-to-prepare-trigger"
                        >
                            <span class="bs-stepper-circle">2</span>
                            <span class="bs-stepper-label"
                                >Documents To Prepare</span
                            >
                        </button>
                    </div>
                    <div class="line"></div>
                    <div class="step" data-target="#upload-documents">
                        <button
                            type="button"
                            class="step-trigger"
                            role="tab"
                            aria-controls="upload-documents"
                            id="upload-documents-trigger"
                        >
                            <span class="bs-stepper-circle">3</span>
                            <span class="bs-stepper-label"
                                >Upload Documents</span
                            >
                        </button>
                    </div>
                </div>
                <div class="bs-stepper-content">
                    <!-- your steps content here -->
                    <div
                        id="select-company-type"
                        class="content"
                        role="tabpanel"
                        aria-labelledby="select-company-type-trigger"
                    >
                        <!-- Select Company Type -->
                        <div class="form-group">
                            <label>Please select company type.</label>
                            <select v-model="companyType" class="form-control">
                                <option :value="companyTypes.SdnBhd">Sdn Bhd</option>
                                <option :value="companyTypes.SolePartnerLlp">Sole Prop / Partnership / LLP</option>
                                <option :value="companyTypes.NewCompaniesAct">New Companies Act</option>
                            </select>
                        </div>

                        <!-- Next Button -->
                        <button
                            @click="nextStep(1)"
                            class="btn btn-primary btn-primary-insv"
                        >
                            Next
                        </button>
                    </div>
                    <div
                        id="documents-to-prepare"
                        class="content"
                        role="tabpanel"
                        aria-labelledby="documents-to-prepare-trigger"
                    >
                        <!-- Title -->
                        <div class="mb-4"><b>Have you prepared everything below?</b></div>

                        <!-- List of checklist -->
                        <ul class="no-bullet">
                            <li class="mb-2" v-for="(document, index) in allDocuments" :key="'document' + index">
                                <div class="custom-control custom-checkbox mb-3">
                                    <input v-model="document.isChecked" :id="'document' + index" type="checkbox" class="custom-control-input">
                                    <label class="custom-control-label" :for="'document' + index">
                                        <div>{{ document.name }} <span v-if="document.required === false">(Optional)</span></div>
                                        <div class="document-description" v-if="document.description">{{ document.description }}</div>
                                    </label>
                                </div>
                                <hr>
                            </li>
                        </ul>

                        <!-- Error message -->
                        <div class="text-danger mb-2" v-if="checkDocumentsError">Please check all items before proceeding!</div>

                        <!-- Back Button -->
                        <button
                            @click="previousStep"
                            class="btn btn-secondary"
                        >
                            Previous
                        </button>

                        <!-- Next Button -->
                        <button
                            @click="nextStep(2)"
                            class="btn btn-primary btn-primary-insv ml-2"
                        >
                            Next
                        </button>
                    </div>
                    <div
                        id="upload-documents"
                        class="content"
                        role="tabpanel"
                        aria-labelledby="upload-documents-trigger"
                    >
                        <!-- Uploaded Document -->
                        <div class="mb-3"><b>Uploaded Documents:</b></div>
                        <div v-if="anyDocumentUploaded === false" class="mb-1">No Documents Uploaded</div>
                        <ul class="no-bullet">
                            <template v-for="(document, index) in documentsToUpload">
                                <li v-if="document.files.length > 0" :key="'uploadedDocuments' + index">
                                    <div class="row">
                                        <div class="col-6">
                                            {{ document.name }}
                                        </div>
                                        <div class="col-6">
                                            <ul>
                                                <li v-for="(file, fileIndex) in document.files" :key="'file' + fileIndex" class="small-text">

                                                    <div class="d-flex justify-content-between">
                                                        <div>
                                                            {{ file.name }}
                                                        </div>
                                                        <a
                                                            href="javascript: void(0);"
                                                            class="delete-button"
                                                            @click="deleteFile(index, fileIndex)"
                                                        >
                                                            <i style="color:red;" class="fas fa-trash-alt"></i>
                                                        </a>
                                                </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <hr>
                                </li>
                            </template>
                        </ul>

                        <!-- List of outstanding documents -->
                        <div v-if="stopUploading === false"><b>List of outstanding documents:</b></div>
                        <ul class="no-bullet">
                            <template  v-for="(document, index) in documentsToUpload" >
                                <li v-if="document.files.length <= 0" :key="'requiredDocument' + index">
                                    <div class="text-danger">{{ document.name }}</div>
                                </li>
                            </template>
                        </ul>

                        <!-- Upload -->
                        <div class="card p-4 mb-4" v-if="stopUploading === false">
                            <div class="mb-2"><b>Upload Documents</b></div>

                            <!-- Select document -->
                            <div v-if="addedFile === false">
                                <div class="form-group">
                                    <label>What document is this?</label>
                                    <select id="documentType" class="form-control">
                                        <template v-for="(document, index) in documentsToUpload">
                                            <option v-if="document.isChecked === true" :key="'documentType' + index" :value="index">{{ document.name }}</option>
                                        </template>

                                    </select>
                                </div>

                                <!-- Input -->
                                <div class="mb-3">
                                    <input
                                        id="upload"
                                        type="file"
                                        name="file"
                                        :class="{ 'is-invalid': uploadError }"
                                    />
                                    <div class="text-danger" v-if="uploadError">Please pick a file first!</div>
                                </div>

                                <!-- Add Button -->
                                <div>
                                    <button
                                        @click="addFile"
                                        class="btn btn-primary btn-primary-insv"
                                    >
                                        Add Attachment
                                    </button>
                                </div>
                            </div>

                            <!-- Ask if more files are needed for current document -->
                            <div v-else>
                                <div class="mb-2">Do you have more of "{{ getCurrentUploadingDocumentType() }}" documents to upload?</div>

                                <button
                                    @click="resetDocument"
                                    class="btn btn-primary btn-primary-insv mr-2"
                                >
                                    Yes
                                </button>
                                <button
                                    @click="nextDocument"
                                    class="btn btn-secondary btn-primary-insv"
                                >
                                    No
                                </button>
                            </div>
                        </div>

                        <!-- Submit Message -->
                        <div class="mb-2" v-if="submitMessage">{{ submitMessage }}</div>

                        <!-- Submit Error -->
                        <div class="mb-2" style="color:red;" v-if="submitError">{{ submitError }}</div>

                        <!-- Back Button -->
                        <button
                            @click="previousStep"
                            :disabled="uploading"
                            class="btn btn-secondary btn-primary-insv"
                        >
                            Previous
                        </button>

                        <!-- Submit Button -->
                        <button
                            :disabled="uploading"
                            class="btn btn-primary btn-primary-insv ml-2"
                            @click="submit"
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="card">
                <div class="card-header">My E-Wallet Application</div>
                <div class="card-body">
                    <p>
                        Current Status:
                        <b
                            class="application-status"
                            :class="{
                                approved: applicationStatus === 'Approved'
                            }"
                            >{{ applicationStatus }}</b
                        >
                    </p>
                    <p>Application Date: {{ addedAt }}</p>
                    <p>Type: {{ getCompanyTypeName }}</p>
                    <div>
                        <button class="btn btn-primary btn-primary-insv mr-2 mb-2" @click="downloadDocument">
                            Download Documents
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Popup modal -->
        <popup-modal ref="popupModalConfirmation" :hasCloseButton="false" title="Uploading Files">
            <template slot="content">
                <p>{{submitMessage}}</p>
            </template>
        </popup-modal>
    </div>
</template>

<script>
import Vue from 'vue';
import { convertToUserReadableDateTime } from '@/utilities';
import { apiPath } from '@/config';
import eWalletApplicationTypes from '@/config/eWalletApplicationTypes';
import { sdnBhdDocuments, solePartnerLlpDocuments, newCompaniesActDocuments } from '@/config/eWalletApplicationRequiredDocuments';
import Stepper from 'bs-stepper';
import _ from 'lodash';
import popupModal from '@/components/popup-modal';
export default {
    'components': {
        popupModal
    },
    'computed': {
        downloadApplicationUrl () {
            return this.applicationId
                ? `${apiPath}EWalletApplication/DownloadApplication?applicationId=${
                    this.applicationId
                }`
                : null;
        },
        getCompanyTypeName () {
            if (parseInt(this.companyType) === eWalletApplicationTypes.SdnBhd) {
                return 'Sdn Bhd';
            } else if (
                parseInt(this.companyType) === eWalletApplicationTypes.SolePartnerLlp) {
                return 'Sole Prop / Partnership / LLP';
            } else if (
                parseInt(this.companyType) ===
                eWalletApplicationTypes.NewCompaniesAct
            ) {
                return 'New Companies Act';
            }
        },
        anyDocumentUploaded () {
            for (const document of this.documentsToUpload) {
                if (document.files.length > 0) {
                    return true;
                }
            }
            return false;
        },
        isAllRequiredDocumentUploaded () {
            for (const document of this.documentsToUpload) {
                if (document.files.length <= 0 && document.required === true) {
                    this.stopUploading = false;
                    return false;
                }
            }
            return false;
        }
    },
    data () {
        return {
            'hasApplied': false,
            'applicationId': '',
            'addedAt': null,
            'applicationStatus': null,
            'submitMessage': '',
            'companyTypes': eWalletApplicationTypes,
            'companyType': 0,
            'documents': [],
            'stepper': null,
            'allDocuments': _.cloneDeep(sdnBhdDocuments),
            'documentsToUpload': _.cloneDeep(sdnBhdDocuments),
            'checkDocumentsError': false,
            'uploadError': false,
            'addedFile': false,
            'documentTypeIndex': 0,
            'submitError': null,
            'uploading': false,
            'stopUploading': false
        };
    },
    'watch': {
        companyType (value) {
            switch (parseInt(value)) {
            case this.companyTypes.SdnBhd:
                this.allDocuments = _.cloneDeep(sdnBhdDocuments);
                break;
            case this.companyTypes.SolePartnerLlp:
                this.allDocuments = _.cloneDeep(solePartnerLlpDocuments);
                break;
            case this.companyTypes.NewCompaniesAct:
                this.allDocuments = _.cloneDeep(newCompaniesActDocuments);
                break;
            }
        }
    },
    mounted () {
        // Setup Stepper
        this.stepper = new Stepper(document.querySelector('.bs-stepper'));

        this.getMyApplication();
    },
    'methods': {
        getMyApplication () {
            this.axios
                .get('EWalletApplication/GetMyApplication')
                .then(({ data }) => {
                    let application = data.data;

                    if (application) {
                        this.hasApplied = true;
                        this.applicationId = application.aid;
                        this.addedAt = application.aa
                            ? convertToUserReadableDateTime(application.aa)
                            : '-';
                        this.applicationStatus =
                            application.ip && (application.ia || application.id)
                                ? application.ia
                                    ? 'Approved'
                                    : 'Disapproved'
                                : 'Pending';

                        this.companyType = application.t;
                        let type = 0;
                        for (const document of application.d) {
                            if (type !== document.type) {
                                this.documents.push({
                                    'type': document.type,
                                    'docIds': [
                                        document.ewalletApplicationDocumentId
                                    ]
                                });
                                type = document.type;
                            } else {
                                let doc = this.documents.find(
                                    doc => doc.type === document.type
                                );
                                doc.docIds.push(
                                    document.ewalletApplicationDocumentId
                                );
                            }
                        }
                    }
                });
        },
        downloadDocument () {
            window.open(
                `${apiPath}EWalletApplication/DownloadApplication?applicationId=${this.applicationId}`
            );
        },
        getDocumentTypeName (type) {
            switch (type) {
            case 0:
                return 'M & A';
            case 1:
                return 'Form 9';
            case 2:
                return 'Form 24';
            case 3:
                return 'Form 44';
            case 4:
                return 'Form 49';
            case 5:
                return 'SSM / LLP';
            case 6:
                return 'Section 14';
            case 7:
                return 'Section 15';
            case 8:
                return 'Section 17';
            case 9:
                return 'Section 48';
            case 10:
                return 'Section 236';
            case 11:
                return 'IC';
            case 12:
                return 'Company Bank Statements';
            case 13:
                return 'Shop Photos';
            case 14:
                return 'Company Write Up';
            case 15:
                return 'Application Form';
            }
        },
        nextStep (step) {
            if (step === 2) {
                if (this.validateCheckedFiles() === false) {
                    return;
                }
            }
            this.documentsToUpload = _.cloneDeep(this.allDocuments.filter(doc => doc.isChecked === true));
            this.stepper.next();
        },
        previousStep () {
            this.stepper.previous();
        },
        validateCheckedFiles () {
            for (const document of this.allDocuments) {
                if (document.isChecked === false && document.required === true) {
                    this.checkDocumentsError = true;
                    return false;
                }
            }

            this.checkDocumentsError = false;
            return true;
        },
        addFile () {
            const element = document.getElementById('upload');
            const index = parseInt(document.getElementById('documentType').value);

            if (element.files.length <= 0) {
                this.uploadError = true;
                return;
            }

            this.uploadError = false;
            this.documentsToUpload[index].files.push(element.files[0]);
            this.documentTypeIndex = index;
            this.addedFile = true;
        },
        resetDocument () {
            this.addedFile = false;
            this.$nextTick(() => {
                document.getElementById('documentType').value = this.documentTypeIndex;
            });
        },
        nextDocument () {
            this.addedFile = false;
            this.$nextTick(() => {
                if (this.documentTypeIndex + 1 > this.documentsToUpload.length - 1) {
                    // document.getElementById('documentType').value = 0;

                    // Check if all required file has been uploaded
                    for (const [index, doc] of this.documentsToUpload.entries()) {
                        if (doc.files.length <= 0 && doc.required === true) {
                            document.getElementById('documentType').value = index;
                            return;
                        }
                    }

                    this.stopUploading = true;
                } else {
                    // Check if all already uploaded
                    for (const doc of this.documentsToUpload) {
                        if (doc.files.length <= 0 && doc.required === true) {
                            document.getElementById('documentType').value = this.documentTypeIndex + 1;
                            return;
                        }
                    }

                    this.stopUploading = true;
                }
            });
        },
        getCurrentUploadingDocumentType () {
            return this.documentsToUpload[this.documentTypeIndex].name;
        },
        deleteFile (documentIndex, fileIndex) {
            const tempFiles = this.documentsToUpload[documentIndex].files;
            tempFiles.splice(fileIndex, 1);
            Vue.set(this.documentsToUpload, 'files', tempFiles);
        },
        validateFiles () {
            for (const document of this.documentsToUpload) {
                if (document.files.length <= 0 && document.required === true) {
                    return false;
                }
            }

            return true;
        },
        appendToFormData () {
            const formData = new FormData();

            formData.append('Type', this.companyType);

            for (const document of this.documentsToUpload) {
                for (const file of document.files) {
                    formData.append(document.requestName, file);
                }
            }

            return formData;
        },
        submit () {
            this.submitError = null;

            const validationResult = this.validateFiles();
            if (validationResult) {
                this.$refs.popupModalConfirmation.show();
                this.uploading = true;
                this.submitMessage = 'Submitting e-wallet application... Please wait, many files are uploading.';
                const formData = this.appendToFormData();

                // Call API
                this.axios
                    .post('EWalletApplication/Apply', formData, {
                        'headers': {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(() => {
                        this.getMyApplication();
                    })
                    .catch(error => {
                        this.isSubmitMessageError = true;
                        if (error.response.data) {
                            this.submitMessage = error.response.data.message;
                        } else {
                            this.submitMessage = 'Error submitting new application. Please try again.';
                        }
                    }).finally(() => {
                        this.uploading = false;
                        this.$refs.popupModalConfirmation.hide();
                    });
            } else {
                this.submitError = 'Please upload all required documents!';
            }
        }
    }
};
</script>

<style scoped>
.application-status {
    color: red;
}

.application-status.approved {
    color: green;
}

.col-form-label {
    line-height: 17px;
}

.document-description {
    font-size: 11px;
    color: red;
}

.small-text {
    font-size: 11px;
}

.active .bs-stepper-circle {
    background-color: #009344;
}

.bs-stepper .step-trigger:focus {
  color: #009344;
  outline: none;
}

ul {
    padding: 0;
}

.no-bullet {
    list-style-type: none;
}

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
     background-color: #009344;
     box-shadow:0 0 3px #009344;
}
 .custom-checkbox .custom-control-input:focus ~ .custom-control-label::before {
     box-shadow:0 0 3px #009344;
}
 .custom-checkbox .custom-control-input:active ~ .custom-control-label::before {
     box-shadow:0 0 3px #009344;
     background:rgba(72, 255, 0, 0.3);
}
 .custom-checkbox .custom-control-label::before {
     border-radius: 0.25rem;
}

</style>
